import { CheckoutFeature } from '@checkout/util-models';
import {
  ClientBrandCode,
  DomainId,
  RequestAction,
  RequestSource,
} from '@domgen/dgx-fe-common';
import { LightstepDeploymentEnvironment } from '@domgen/dgx-fe-lightstep';
import { RegistrationFeature } from '@us-registration/util-models';
import { APP_CMS_COMPONENT_MAPPING } from '../../app/constants/cms-component-mapping.constant';
import { TRACE_HEADER_BLACKLIST_REGEX } from '../../app/constants/lightstep/lightstep-trace-blacklist.regex';
import { TRACE_HEADER_WHITELIST_REGEX } from '../../app/constants/lightstep/lightstep-trace-whitelist.regex';
import { AppBuildConfig } from '../../app/models/build/app-build-config.interface';

export const buildConfig: AppBuildConfig = {
  applianceRegistrationLimit: 10,
  buildFeatures: {
    [CheckoutFeature.Ipid]: false,
    [CheckoutFeature.TermsAndConditions]: false,
    [RegistrationFeature.AnnualPlans]: false,
    [RegistrationFeature.ApplianceDetailsSteppedForm]: true,
    [RegistrationFeature.MaintenanceEnabled]: false,
    [RegistrationFeature.PrivacyPolicyCheckbox]: true,
    [RegistrationFeature.ProtectionUpsellCheckbox]: true,
    [RegistrationFeature.ProtectionUpsellPage]: true,
    [RegistrationFeature.SendRegistriaOrderInfo]: true,
    [RegistrationFeature.WibEnabled]: false,
  },
  callCentreNumber: '888-900-3381',
  checkout: {},
  cms: {
    brandContentAppRootPath: 'us',
    brandPrivacyPolicy: true,
    brandTermsAndConditions: true,
    componentMapping: APP_CMS_COMPONENT_MAPPING,
  },
  defaultDomainId: DomainId.Whirlpool,
  domainIdMapping: {
    [DomainId.Amana]: /reg\.amana\.[\w.-]*|register\.amana\.com/,
    [DomainId.JennAir]: /reg\.jennair\.[\w.-]*|register\.jennair\.com/,
    [DomainId.KitchenAid]: /reg\.kitchenaid\.[\w.-]*|register\.kitchenaid\.com/,
    [DomainId.Maytag]: /reg\.maytag\.[\w.-]*|register\.maytag\.com/,
    [DomainId.Whirlpool]: /reg\.whirlpool\.[\w.-]*|register\.whirlpool\.com/,
  },
  lightstep: {
    collectorUrl: 'https://ingest.lightstep.com/traces/otlp/v0.9',
    debug: false,
    deploymentEnvironment: LightstepDeploymentEnvironment.Development,
    serviceName: 'dgx-reg-spa-us-sidedoor-reg',
    serviceVersion: '1.0.0',
    /**
     * Lightstep Trace Whitelist Configuration.
     * This configuration allows specific domains whitelisted.
     * This configuration blocks specific domains blacklisted.
     */

    traceHeaderWhitelist: [
      TRACE_HEADER_WHITELIST_REGEX,
      TRACE_HEADER_BLACKLIST_REGEX,
    ],
  },
  modelNumberSearchEnabledBrands: [
    ClientBrandCode.Amana,
    ClientBrandCode.KitchenAid,
    ClientBrandCode.MaytagUS,
    ClientBrandCode.WhirlpoolUS,
  ],
  retailerFieldEnabledBrands: [],
  requestAction: RequestAction.OnlineRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralUS,
};
